// John Eldhose 20190201
import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import { FileDownload } from '@material-ui/icons';
import { getAccount } from '../Api/getAccount';
import { report } from '../Api/report';

class Report extends Component {

  state = {
    loading: true,
    Account: [],
    data: []
  }
  componentWillMount() {
    getAccount()
      .then((acc) => {
        if(acc['status'] === 'true')
          this.setState({ Account: acc['data'] });
      })
      .catch((error) => {
        console.log(error);
      })
    report()
      .then((rpt) => {
        this.setState({ data: rpt.data, loading: false });
        window.print();
      })
      .catch(() => {
        this.setState({ loading: false });
      })
  }
  Upgraded = (row) => {
    if(row.ORIGSERIALNUM === null || row.ORIGSERIALNUM === '')
      return '';
    else
      return <span>
        <br />
        <small>Upgraded from: { row.ORIGSERIALNUM }</small>
      </span>;
  }

  render() {
    if(this.state.loading)
      return (
        <div style={{ textAlign: 'center' }}>
          <style>{'body { background: #fff; }'}</style>
          <div style={{ height: '200px' }}>&nbsp;</div>
          <CircularProgress />
        </div>
      );
    else {
      const now = new Date();
      return (
        <div>
          <style>{'body { background: #fff; font-family: Calibri; font-size: 12pt; }'}</style>
          <style>{'table { border-collapse: collapse; }'}</style>
          <style>{'@media print { body { font-family: Calibri; font-size: 12pt; } }'}</style>
          <table width="100%" border="1" bordercolor="lightgray" cellPadding="5">
            <thead>
              <tr><th colSpan='7'>
                <table width='100%'><thead>
                <tr>
                  <th align='left'><img src='logo.png' alt='Carlson Logo' /></th>
                  <th align='right'>
                    <a href='https://www.carlsonsw.com'>Carlson Software</a><br />
                    { now.toLocaleDateString('default', { year: 'numeric', month: 'long', day: 'numeric' }) }
                  </th>
                </tr>
                <tr>
                  <th colSpan='2' style={{ padding: '15px 35px 25px 35px' }}>
                    <table width='100%' border="1" bordercolor="lightgray" cellPadding="5"><thead>
                      <tr>
                        <th align='right'>Company Name:</th>
                        <th align='left'>{ this.state.Account.accname }</th>
                        <th align='right'>Account Manager: </th>
                        <th align='left'>{ this.state.Account.rep }</th>
                      </tr>
                      <tr>
                        <th align='right'>Customer ID: </th>
                        <th align='left'>{ this.state.Account.accid }</th>
                        <th align='right'>Phone Number: </th>
                        <th align='left'>{ this.state.Account.repphone }</th>
                      </tr>
                      <tr>
                        <th align='right'>Carlson Dealer:</th>
                        <th align='left'>{ this.state.Account.dealer }</th>
                        <th align='right'>Email Address: </th>
                        <th align='left'>{ this.state.Account.repemail }</th>
                      </tr>
                    </thead></table>
                  </th>
                </tr>
                </thead></table>
              </th></tr>
              <tr>
                <th>Product</th>
                <th>Serial Number</th>
                <th>Expiration</th>
                <th>Modules</th>
                <th>Registered to</th>
                <th>Registration Date</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              { this.state.data.map((row) => {
                return (

                  <tr key={ row.SERIALNUM }>
                    <td>{ row.PRODUCTNAME }</td>
                    <td>{ row.SERIALNUM } { this.Upgraded(row) }</td>
                    <td>{ row.EXPIRY_DATE }</td>
                    <td>{ row.Modules }</td>
                    <td>{ row.reg.user }</td>
                    <td>{ row.reg.date }</td>
                    <td><a href={ row.download }><FileDownload /></a></td>
                  </tr>

                );
              }) }
            </tbody>
            <tfoot>
              <tr>
                <th colSpan='7'>
                  Software Download URL: http://www.carlsonsw.com/support/software-downloads/
                </th>
              </tr>
            </tfoot>
          </table>

        </div>
      );
    }
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/components/Report.js